<template>
  <header class="header sticky-header">
    <div class="inside clearfix">
      <div class="sticky-trigger"></div>

      <div class="header__logo" >
        <a tabindex="0" @click="refreshPage()" @keyup.enter="refreshPage()" @keydown.space.prevent="refreshPage()">
          <img src="@/assets/images/ubs_logo.svg" alt="UBS-Logo">
        </a>
        <div class="main-heading">
          {{ $t('header:heading') }}
        </div>
      </div>
      <div class="meta">
        <LanguageSelector/>
      </div>
    </div>
  </header>
</template>

<script>
import LanguageSelector from '@/components/LanguageSelector'
import answerHandling from '@/mixins/answerHandling'
import current from '@/mixins/current'

export default {
    name: 'Header',
    components: {
        LanguageSelector
    },
    mixins: [current, answerHandling],
    computed: {
        activeLanguage() {
            return this.$store.state.app.language
        },
        isIframe: function() {
            return this.$store.state.app.entrypoint === 'iframe'
        },
        sectionCompleted: function() {
            return this.$store.getters['app/sectionCompleted']
        },
        sectionTitle: function() {
            return this.$store.getters['app/sectionTitle']
        },
        section: function() {
            return this.$store.getters['app/section']
        }
    },
    methods: {
        refreshPage() {
            this.$store.commit('answers/RESET_ANSWERS')
            this.resetStep()
            this.setSection(1)
            this.setSectionCompleted(0)
            this.setActiveQuestionStep(0)
            this.setSectionTitle('operationalTransferability')

            this.$router.push({
                name: 'home'
            })
        }
    }
}
</script>
